import React, { useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Modal, Input } from 'semantic-ui-react';
import Joyn2Button from '../common/Joyn2Button';
import { FILTER_OPERATION } from '../../HelperMethods/enums';
import cardStyles from './FilterCard.module.css';

const addConditionsToFilter = ({ field, reqFilter, colDefDict }) => {
  const { operator } = reqFilter;
  if (!operator) {
    return {
      conditions: [reqFilter],
      header: colDefDict[field].headerName,
    };
  }
  const conditions = [];
  Object.keys(reqFilter).forEach((filterKey) => {
    if (filterKey.startsWith('condition')) {
      conditions.push(reqFilter[filterKey]);
    }
  });
  return {
    conditions,
    operator,
    header: colDefDict[field].headerName,
  };
};

const filterToView = ({ taskListGridApi, filterModel }) => {
  const colDefs = taskListGridApi?.getColumnDefs?.() || [];
  const colDefDict = _.keyBy(colDefs, 'field');
  const reqObjct = {};
  Object.keys(filterModel).forEach((key) => {
    if (key.endsWith('_1')) {
      const field = `${key.substr(0, key.length - 2)}`;
      const reqFilter = filterModel[key];
      reqObjct[field] = addConditionsToFilter({ field, reqFilter, colDefDict });
    } else if (!key.endsWith('_1')) {
      const reqFilter = filterModel[key];
      reqObjct[key] = addConditionsToFilter({ field: key, reqFilter, colDefDict });
    }
  });
  return reqObjct;
};

const filterNamevalidation = (name, onConfirm, allTaskFilters, handleError) => {
  const indexofFilteredName = allTaskFilters.findIndex((filterObj) => filterObj.name === name);

  if (indexofFilteredName === -1) onConfirm(name);
  handleError('Filter name exist');
};

const FilterSaveModal = ({
  saveModal,
  handleToggleSaveFilter,
  selectedFilter,
  taskListGridApi,
  allTaskFilters,
  filterModal,
}) => {
  const [error, handleError] = useState('');
  const { open, modalType, onConfirm } = saveModal;
  const [filterName, handleChange] = useState(modalType === FILTER_OPERATION.SAVE ? '' : selectedFilter.name);
  const filterModaltobeSaved = filterModal.filterModel;
  const tosaveFilterModal = filterModaltobeSaved
    ? filterToView({ taskListGridApi, filterModel: filterModaltobeSaved })
    : {};
  const [filters, setfilters] = useState();
  const [filterData, setfilterData] = useState();
  const handleFilterNameChange = (e) => {
    handleChange(e.target.value);
  };

  React.useEffect(() => {
    if (saveModal.idClicked) {
      const reqFilter = allTaskFilters.find(({ id }) => id === saveModal.idClicked);
      let filterModel;
      if (saveModal.idClicked === selectedFilter?.id) {
        filterModel = filterModal.filterModel;
      } else {
        filterModel = reqFilter.filter;
      }
      setfilterData(() => filterModel);
      setfilters(() => filterToView({ taskListGridApi, filterModel }));
      handleChange(() => reqFilter.name);
    }
  }, [setfilters, handleChange, setfilterData]);

  return (
    <>
      <Modal size="mini" open={open}>
        <Modal.Header>
          {modalType === FILTER_OPERATION.UPDATE && <div>Update Filter</div>}
          {modalType === FILTER_OPERATION.SAVE && <div>Save Filter</div>}
          {modalType === FILTER_OPERATION.DELETE && <div>Delete Filter</div>}
        </Modal.Header>
        <Modal.Content>
          {modalType === FILTER_OPERATION.UPDATE && <div>Are you sure you want to update the filter ?</div>}
          {modalType === FILTER_OPERATION.DELETE && <div>Are you sure you want to delete the filter ?</div>}
          {modalType !== FILTER_OPERATION.DELETE && (
            <div style={{ marginTop: '12px' }}>
              <div>
                <label>
                  Filter Name <span style={{ color: 'red' }}>*</span>
                </label>
              </div>
              <Input>
                <input value={filterName} onChange={handleFilterNameChange} />
              </Input>
              {error && <div className="errorText">*{error}</div>}
            </div>
          )}
          {modalType === FILTER_OPERATION.UPDATE && (
            <div className={cardStyles.cardContent}>
              {Object.values(filters || {}).map(({ conditions, operator, header }) => (
                <div className={cardStyles.row} key={header}>
                  {conditions.map(({ type, filter, values }, index) => (
                    <div className={cardStyles.conditionRow}>
                      <div className={cardStyles.subRow}>
                        <div className={cardStyles.filterName}>{header}</div>
                        <div className={cardStyles.nooverflowtext}>{!_.isNil(filter) ? filter : values.join(', ')}</div>
                      </div>
                      <div className={cardStyles.subRow}>
                        <div className={cardStyles.filterType}>{type}</div>
                      </div>
                      {index + 1 !== conditions.length && <div style={{ marginTop: '10px' }}>{operator}</div>}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
          {modalType === FILTER_OPERATION.SAVE && (
            <div className={cardStyles.cardContent}>
              {Object.values(tosaveFilterModal || {}).map(({ conditions, operator, header }) => (
                <div className={cardStyles.row} key={header}>
                  {conditions.map(({ type, filter, values }, index) => (
                    <div className={cardStyles.conditionRow}>
                      <div className={cardStyles.subRow}>
                        <div className={cardStyles.filterName}>{header}</div>
                        <div className={cardStyles.nooverflowtext}>{!_.isNil(filter) ? filter : values.join(', ')}</div>
                      </div>
                      <div className={cardStyles.subRow}>
                        <div className={cardStyles.filterType}>{type}</div>
                      </div>
                      {index + 1 !== conditions.length && <div style={{ marginTop: '10px' }}>{operator}</div>}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          <div style={{ display: 'flex', float: 'right', padding: '10px' }}>
            <Joyn2Button
              margin="0 10px 0 0"
              size="large"
              label="Cancel"
              color="light"
              type="button"
              btnType="secondary"
              onClick={handleToggleSaveFilter}
            />
            {modalType === FILTER_OPERATION.UPDATE && (
              <Joyn2Button
                size="large"
                label="Update Filter"
                type="submit"
                margin="0 10px 0 0"
                onClick={
                  filterName ? () => onConfirm(filterName, filters, filterData) : () => handleError('Name is Required')
                }
              />
            )}
            {modalType === FILTER_OPERATION.SAVE && (
              <>
                <Joyn2Button
                  size="large"
                  label="Save Filter"
                  type="submit"
                  margin="0 10px 0 0"
                  onClick={
                    filterName
                      ? () => filterNamevalidation(filterName, onConfirm, allTaskFilters, handleError)
                      : () => handleError('Name is Required')
                  }
                  // onClick={filterName ? () => onConfirm(filterName) : () => handleError('Name is Required')}
                />
              </>
            )}
            {modalType === FILTER_OPERATION.DELETE && (
              <Joyn2Button size="large" label="Delete Filter" type="submit" margin="0 10px 0 0" onClick={onConfirm} />
            )}
          </div>
        </Modal.Actions>
      </Modal>
    </>
  );
};

FilterSaveModal.propTypes = {
  filterModal: PropTypes.shape({
    filterModel: PropTypes.object,
    updated: PropTypes.bool,
  }).isRequired,
  saveModal: PropTypes.shape({
    open: PropTypes.bool,
    modalType: PropTypes.string,
    onConfirm: PropTypes.func,
    idClicked: PropTypes.string,
  }).isRequired,
  handleToggleSaveFilter: PropTypes.func.isRequired,
  selectedFilter: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  taskListGridApi: PropTypes.object.isRequired,
  allTaskFilters: PropTypes.array,
};

export default FilterSaveModal;
